import React from 'react';

import * as types from '../../../../types/types';
import { ReportQueryFormPage } from './ReportQueryFormPage';


export function QueryEditorReport(props: types.ReportProps) {
  props.setCurrentReportComponent("downloadReport")
  return (
    <div>
    <ReportQueryFormPage {...props} />
    </div>
  )
}
